import { useLazyQuery, useMutation } from '@apollo/client'
import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import Select from '../../../Components/Autocompelte/Select'
import { SkyButton, SkyOutlinedButton } from '../../../Components/Buttons'
import {
  ALLOCATE_CAB_BOOKING,
  GET_CAB_BY_FLEET_OWNER,
  GET_FLEET_DRIVERS_BY_OWNER_ID,
} from '../../../Services/cabggl'
import { getDecryptedSessionStorageVariable } from '../../../utils/encryptStorage'
import OffDuty from './OffDuty'
import StartDuty from './StartDuty'

const MobileAllocate = ({ onClose, selectedBooking, refetch }) => {
  const [fleetDriverOptions, setFleetDriverOptions] = useState([])
  const [updateStartDuty, setUpdateStartDuty] = useState(false)
  const [updateOffDuty, setUpdateOffDuty] = useState(false)
  const [loadFleetDrivers] = useLazyQuery(GET_FLEET_DRIVERS_BY_OWNER_ID)
  const [loadFleetCabs] = useLazyQuery(GET_CAB_BY_FLEET_OWNER)
  const [allocateCabBooking, { data, loading, error }] =
    useMutation(ALLOCATE_CAB_BOOKING)
  const fleetid = getDecryptedSessionStorageVariable('fleetId')
  const fletOwnerName = getDecryptedSessionStorageVariable('firstName')
  const [fleetCabOptions, setFleetCabOptions] = useState([])
  const [selectedDriver, setSelectedDriver] = useState({
    label: `${selectedBooking.driverId?.firstName ?? ''} ${
      selectedBooking.driverId?.lastName ?? ''
    } ${
      selectedBooking.driverId?.mobileNumber
        ? `(${selectedBooking.driverId.mobileNumber})`
        : ''
    }`.trim(),
    value: selectedBooking?.driverId?._id,
  })
  const [selectedCab, setSelectedCab] = useState({
    label:
      selectedBooking.cabId?.variant && selectedBooking.cabId?.carNo
        ? `${selectedBooking.cabId?.variant ?? ''} (${
            selectedBooking.cabId?.carNo ?? ''
          })`.trim()
        : '',
    value: selectedBooking?.cabId?._id,
  })
  const fetchFleetDrivers = async () => {
    try {
      if (fleetid) {
        await loadFleetDrivers({
          variables: { fleetOwnerId: fleetid },
        }).then((res) => {
          const options = res?.data?.getDriverByFleetOwner?.map((driver) => ({
            label: `${driver.firstName ?? ''} ${driver.lastName ?? ''} ${
              driver.mobileNumber ? `(${driver.mobileNumber})` : ''
            }`.trim(),
            value: driver._id,
          }))
          console.log('options', options)
          setFleetDriverOptions(options)
        })
      } else {
        console.log('No FleetOwnerId available')
      }
    } catch (err) {
      console.error('Error fetching fleet drivers:', err)
    }
  }
  const fetchFleetCabs = async () => {
    try {
      if (fleetid) {
        await loadFleetCabs({
          variables: { fleetOwnerId: fleetid },
        }).then((res) => {
          const options = res?.data?.getCabByFleetOwner?.map((cab) => ({
            label:
              cab?.variant && cab?.carNo
                ? `${cab?.variant ?? ''} (${cab?.carNo ?? ''})`.trim()
                : '',
            value: cab?._id,
          }))
          setFleetCabOptions(options)
        })
      } else {
        console.log('No FleetOwnerId available')
      }
    } catch (err) {
      console.error('Error fetching fleet drivers:', err)
    }
  }
  useEffect(() => {
    fetchFleetDrivers()
    fetchFleetCabs()
  }, [])

  const handleAllocateCabBooking = async () => {
    if (!selectedDriver?.value || !selectedCab?.value) {
      toast.error('Please select driver and cab')
      return
    }
    try {
      await allocateCabBooking({
        variables: {
          createCabBookingInput: {
            id: selectedBooking?.id,
            driverId: selectedDriver?.value,
            cabId: selectedCab?.value,
            fleetOwnerId: fleetid,
            updatedBy: fleetid,
            updatedName: fletOwnerName,
          },
        },
      })
        .then((response) => {
          if (response?.data?.allocateCabBooking?.id) {
            toast.success('Driver allocated successfully')
            setUpdateOffDuty(false)
            setUpdateStartDuty(true)
            refetch()
            onClose()
          }
        })
        .catch((error) => {
          if (
            error.message &&
            error.message.includes('Please Recharge Your Account')
          ) {
            toast.warn('Your account needs to be recharged.')
            onClose()
          }
          if (error.message) {
            toast.error(error.message)
          }
        })
    } catch (err) {
      toast.error('Something went wrong')
      onClose()
    }
  }
  return (
    <div>
      <div className="fixed z-20 inset-0 bg-black bg-opacity-50 flex justify-center items-center">
        <div className="bg-white rounded-lg p-6 w-11/12 sm:w-96 shadow-lg relative">
          <div className="text-center mb-4 flex justify-between">
            <h4 className="text-lg font-semibold">Booking Details</h4>
            <button
              onClick={() => {
                onClose()
              }}
              className="text-xl font-bold text-red-500 hover:text-red-700"
            >
              X
            </button>
          </div>
          <div>
            <strong>Selected Booking ID:</strong> {selectedBooking?.id}
            {selectedBooking?.status === 'New Booking' && (
              <div className="w-full justify-start flex gap-10 flex-col mt-5">
                <div className="w-full text-start max-w-96">
                  <div>
                    <label className="text-stone-700 text-xs font-semibold mt-2">
                      Search for driver
                    </label>
                    <Select
                      selected={selectedDriver}
                      labelValue={'Select Driver'}
                      placeholderValue={'Select Driver'}
                      options={fleetDriverOptions}
                      onSelect={setSelectedDriver}
                    />
                    <div className="mt-4">
                      <Select
                        selected={selectedCab}
                        labelValue={'Select Cab'}
                        placeholderValue={'Select Cab'}
                        options={fleetCabOptions}
                        onSelect={setSelectedCab}
                      />
                    </div>
                  </div>
                </div>
                <div className="flex gap-2">
                  <SkyButton
                    label={'Allocate Driver'}
                    onClick={() => {
                      handleAllocateCabBooking()
                    }}
                  />
                  <SkyOutlinedButton
                    label={'Cancel'}
                    onClick={() => onClose()}
                  />
                </div>
              </div>
            )}
            {selectedBooking?.status === 'Line Up' && (
              <StartDuty
                isOpen={updateStartDuty}
                onClose={onClose}
                selectedBooking={selectedBooking}
                refetch={refetch}
              />
            )}
            {selectedBooking?.status === 'Start Duty' && (
              <OffDuty
                isOpen={updateOffDuty}
                onClose={onClose}
                selectedBooking={selectedBooking}
                refetch={refetch}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default MobileAllocate
